import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import TrackApi from "~~/package/apis/track/TrackApi";
import { TrackModel } from "~~/package/mapper/track/model/TrackModel";
import { TrackHelper } from "~~/package/mapper/track/TrackHelper";
import type TrackFilterResponse from "~~/package/apis/track/response/TrackFilterResponse";
import type TrackResponse from "~~/package/apis/track/response/TrackResponse";
import { PageModel } from "~~/package/mapper/common/model/PageModel";
import type CustomResponse from "~~/package/types/ResponseType";
import { SkillAdvanceType } from "~~/package/mapper/track/model/SkillAdvanceType";
import { TrackStatusType } from "~~/package/mapper/track/model/TrackStatusType";
import { SkillAdvanceMyTrackModel } from "~~/package/mapper/track/model/SkillAdvanceMyTrackModel";

export default class TrackMapper {
    protected trackApi: TrackApi;

    constructor(context: ApplicationContextInterface) {
        this.trackApi =  context.getService<TrackApi>(DependencyInjectId.TrackApi)
    }

    public async getAdvanceList(filter: string[], page: number, itemSize: number, advanceType: SkillAdvanceType, field?: string): Promise<PageModel<TrackModel>> {
        const trackResponse: CustomResponse<PageModel<TrackModel>> = (await this.trackApi.getAdvanceList(filter, page, itemSize, advanceType, field)).data;
        return TrackHelper.mappingPageTrackList(trackResponse.data, advanceType) as PageModel<TrackModel>;
    }

    public async getMyAdvanceList(page: number, itemSize: number, lang: string, filter: string[], advanceType: SkillAdvanceType, field?: string, status?: TrackStatusType): Promise<PageModel<SkillAdvanceMyTrackModel>> {
        const responseData: CustomResponse<PageModel<SkillAdvanceMyTrackModel>> = (await this.trackApi.getMyAdvanceList(page, itemSize, lang, filter, advanceType, field, status)).data;
        return TrackHelper.mappingPageTrackList(responseData.data, advanceType!) as PageModel<SkillAdvanceMyTrackModel>;
    }

    public async getTrack(id: number, lang: string, advanceType: SkillAdvanceType): Promise<TrackModel> {
        const trackResponse: CustomResponse<TrackModel> = (await this.trackApi.getTrack(id, lang)).data;
        return TrackHelper.mappingTrack(trackResponse.data, advanceType);
    }

    public async startTrack(id: number): Promise<Boolean> {
        const responseData: CustomResponse<Boolean> = (await this.trackApi.startTrack(id)).data;
        return responseData.data;
    }

    public async getTrackFilter(includes?: string): Promise<TrackFilterResponse[]> {
        const responseData: CustomResponse<TrackFilterResponse[]> = (await this.trackApi.getTrackFilter(includes)).data;
        return responseData.data;
    }
}
